import React from 'react'

import FormSignUp from 'src/comps/FormSignUp'

import styles from './styles.module.css'

const Content = ({ returnUrl }: { returnUrl: string | null }) => {
  return (
    <div className={styles.contentBase}>
      <FormSignUp returnUrl={returnUrl} />
    </div>
  )
}

export default Content
